import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/pages/Home";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme";
import Login from "./pages/Login";
import ResetPass from "./pages/ResetPass";
import { Admin } from "./RoleManagement";
import UpdateMemberReceipts from "./components/member/UpdateMemberReceipts";
import ApiInterceptor, {
  getSessionDuration,
} from "./services/interceptors/ApiInterceptor";
import { createBrowserHistory } from "@remix-run/router";
import { store } from "./redux/store";
import MemberReceiptTab from "./pages/MemberReceiptTab";
import VerifyOTP from "./pages/VerifyOTP";
import { constant } from "./constants";
import {
  getDomainUrl,
  getURLDomain,
  getURLPath,
} from "./components/forms/utility";
import InvalidUrl from "./pages/InvalidUrl";
import useGetMerchants from "./Hooks/merchant/useGetMerchants";
import ShowTheModuleToRedirectToLogin from "./services/interceptors/ShowTheModuleToRedirectToLogin";
import Bugsnag from "@bugsnag/js";
import { useAppSelector } from "./redux/hooks";
import { useEffect, useState } from "react";
import TimeOutModal from "./services/interceptors/TimeOutModal";
import MaintenancePage from "./pages/MaintenancePage";
import Redirect from "./components/redirect/Redirect";

function App() {
  const { firstName, lastName, email, username } = useAppSelector(
    (state) => state.persistReducers.login
  );
  const fullname = `${firstName} ${lastName}`;

  Bugsnag.setUser(username, email, fullname);

  const history = createBrowserHistory();
  ApiInterceptor.setupInterceptors(store, history);
  constant.domain = getDomainUrl();
  const module = getDomainUrl() ? "" : getURLDomain();

  const [showPopup, setShowPopup] = useState(false);

  const handleClosePopup = () => {
    setShowPopup(false);
    localStorage.setItem("popupShown", "true");
  };

  useEffect(() => {
    const checkSessionTime = () => {
      const expiresIn = localStorage.getItem("expiresIn");
      const sessionDuration = getSessionDuration();
      const popupShown = localStorage.getItem("popupShown");
      if (expiresIn && sessionDuration && popupShown !== "true") {
        const timeRemaining = parseInt(expiresIn) - sessionDuration;
        if (timeRemaining <= 60) {
          setShowPopup(true);
        }
      }
    };

    const intervalId = setInterval(checkSessionTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (
      window.location.pathname &&
      window.location.pathname !== "/invalid-url"
    ) {
      let domain = getURLPath();
      if (domain === "invalid-url") {
        history.replace(`/${domain}`);
        window.location.reload();
      }
    }
  }, []);

  useGetMerchants();

  if (process.env.REACT_APP_MAINTENANCE_PAGE === "true") {
    return <MaintenancePage />;
  }

  return (
    <ThemeProvider theme={theme}>
      <Router basename={`/${constant.domain}`}>
        <Routes>
          <Route path={`${module}/login`} element={<Login />} />
          <Route
            path="/tokenRefreshError"
            element={<ShowTheModuleToRedirectToLogin />}
          />
          <Route path="/redirect" element={<Redirect />} />
          <Route path="/memberReceipts" element={<MemberReceiptTab />} />
          <Route path="/resetPassword" element={<ResetPass />} />
          <Route path="/verifyOTP" element={<VerifyOTP />} />
          <Route element={<Admin />}>
            <Route path="/*" element={<Home />} />
          </Route>
          <Route
            path="/updateMemberReceipt"
            element={<UpdateMemberReceipts />}
          />
          <Route path="/invalid-url" element={<InvalidUrl />} />
          <Route path="*" element={<InvalidUrl />} />
        </Routes>
      </Router>
      {showPopup && !window.location.pathname.includes("/login") && (
        <TimeOutModal onClose={handleClosePopup} />
      )}
    </ThemeProvider>
  );
}

export default App;
